import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import { connect } from 'react-redux';
import images from '../../../images';
import { __ } from '../../../locales';
import { iframeCall, log } from '../../../helpers/iframeHelper';

const customModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '75%',
    paddingBottom: 10,
    borderRadius: 15,
    border: 'none'
  }
};

const PlayAgainButton = styled.button`
  margin-bottom: 5px;
  margin-top: 5px;
  width: 96%;
  justify-content: center;
  align-items: center;
  background-color: #00008B;
  color: white;
  position: relative;
`;

const IamDoneButton = styled.button`
  margin-top: 5px;
  width: 96%;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  color: #00008B;
  position: relative;
`;

const CongratulationsText = styled.h2`
  margin-top: 10%;
  font-size: 30px;
`;

const CongratulationsContext = styled.h2`
  margin-bottom: 10%;
  font-size: 16px;
`;

const CongratulationsImage = styled.img`
  height: 90%;
  margin-right: 3%;
  width: 90%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-left: 5%;
  margin-top: 3%;
  margin-bottom: 5%;
  max-width: 90%;
  max-height: 90%;
`;

const CloseImage = styled.img`
  height: ${window.innerWidth / 20}px;
  width: ${window.innerWidth / 20}px;
  border-radius: 50%;
  margin-top: 2%;
  margin-left: 8%;
  margin-right: 92%;
`;

const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  width: 30px;
  height: 30px;
  align-self: flex-end;
  padding: 0 20px;
`;

/**
 * This component is a modal to show congratulations to the user when user passed
 * all the levels and finished th game completely.
 *
 * Also this compoent has three buttons for play the game again or
 * going back to discovery zone tab or closing the modal.
 *
 */

const CongratulationsModal = ({
  clearedLevel,
  onClose,
  playAgain,
  iamDone,
  appVersion
}) => {
  const [modalIsOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (Number(appVersion.split('.').join('')) >= 1810) {
      iframeCall('rrGameFinish');
    }
  }, []);

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={onClose}
      style={customModalStyles}
      overlayClassName="signup-modal-overlay"
    >
      <CloseButton accessibilityLabel="Close" onClick={closeModal}>
        <CloseImage src={images.close} alt="Close" />
      </CloseButton>
      <CongratulationsText>
        {__('app.congratulations')}
      </CongratulationsText>
      <CongratulationsContext>
        {__('app.successfully_finished_level')}
        {' '}
        {clearedLevel}
        {'!'}
      </CongratulationsContext>
      <CongratulationsImage
        src={images.great_job}
        alt="Great job celebration illustration"
      />
      <PlayAgainButton onClick={playAgain}>
        {__('app.play_again_button')}
      </PlayAgainButton>
      <IamDoneButton onClick={iamDone}>
        {__('app.i_am_done_button')}
      </IamDoneButton>
    </Modal>
  );
};

export default connect((state) => ({
  appVersion: state.app.appVersion,
}), null)(CongratulationsModal);
